import { useContext } from 'react';
import { logg } from '@/util/logg';
import { GameContext } from '@/state/contexts';

export function useTutorial() {
    const context = useContext(GameContext);

    if (!context) {
        throw new Error('useTutorial must be used within a GameContext');
    }

    const { isTutorial, stepTutorial } = context;

    const tutorialCheck = (step: number) => {
        logg('Tutorial Step', stepTutorial, 'Step check: ', step);
        if (isTutorial === false || isTutorial == null) return true;

        return stepTutorial > step;
    };

    return {
        tutorialCheck,
        isTutorial,
        stepTutorial,
    };
}